// extracted by mini-css-extract-plugin
module.exports = {"link":"EventCardCTAButton_link__3Xr_8","container":"EventCardCTAButton_container__e-Qnf","arrowIcon":"EventCardCTAButton_arrowIcon__1XCVK"};